import React, { Component, useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import { instanceOf } from "prop-types";
import { withCookies, Cookies } from "react-cookie";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import "../../../custom-css/Custom.css";
import {
  getProducts,
  fetchData,
  getCartProducts,
  addPromocode,
  billing_Address,
  shipping_Address,
  guest_email,
  getOffers,
  get_user_lang
} from "../../../repository";
import isEmail from "validator/lib/isEmail";
import Shipping from "./Shipping";
import Delivery from "./Delivery";
import Billing from "./Billing";
import Payment from "./Payment";
import Ordersummary from "./Ordersummary";
import Products from "./products";

let BASE_URL;
let cart_url;
const cookies = new Cookies();
let csrftoken = "";
let userlang = "";
// const userlang = cookies.get('cbs_language');
let checkout_url;
let home_url;
let page_category;
let product_url;
let product = [];
const { postcodeValidator } = require("postcode-validator");
const invalid_postal_codes = [
  "A0R",
  "A2V",
  "A3V",
  "A3Y",
  "A3Z",
  "B9A",
  "E1L",
  "E3G",
  "E3X",
  "G0G",
  "G4T",
  "J0M",
  "R0B",
  "S0P",
  "T0P",
  "T0V",
  "V0L",
  "V0T",
  "V0V",
  "V0W",
  "X0A",
  "X0B",
  "X0C",
  "X0E",
  "X0G",
  "X1A",
  "Y0A",
  "Y0B",
  "Y1A",
  "A0P",
  "H7N"
];

if (
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1"
) {
  BASE_URL = "https://dev.cocoonsealy.net";
} else if (window.location.hostname === "dev.cocoonsealy.net") {
  BASE_URL = "https://dev.cocoonsealy.net";
} else if (window.location.hostname === "staging.cocoonbysealy.ca") {
  BASE_URL = "https://staging.cocoonbysealy.ca";
} else if (window.location.hostname === "cocoonbysealy.ca") {
  BASE_URL = "https://cocoonbysealy.ca";
}

// console.log(`(checkout.js) window location is: `, window.location.hostname);

const useMountEffect = fun => useEffect(fun, []);

const utilizeScroll = () => {
  const htmlElRef = React.createRef();
  const executeScroll = () => {
    // console.log("Checkout Y-Coord: ", htmlElRef.current.offsetTop);
    window.scrollTo(0, htmlElRef.current.offsetTop);
  };

  return { executeScroll, htmlElRef };
};

class Checkout extends Component {
  constructor(props) {
    super(props);
    this.elScroll = utilizeScroll();
    this.state = {
      step: 1,
      shipping_first_name: "",
      shipping_last_name: "",
      shipping_line1: "",
      shipping_line2: "",
      shipping_line4: "",
      shipping_state: "",
      shipping_postcode: "",
      shipping_country: "CA",
      shipping_phone_number: "",
      buzzer: "",
      guest_email: "",
      shipping_notes: "",
      shipping_first_nameError: "",
      shipping_last_nameError: "",
      shipping_line1Error: "",
      shipping_line2Error: "",
      shipping_line4Error: "",
      shipping_stateError: "",
      shipping_postcodeError: "",
      shipping_phone_numberError: "",
      buzzerError: "",
      guest_emailError: "",
      shipping_method_0: "",
      billing_first_name: "",
      billing_last_name: "",
      billing_line1: "",
      billing_line2: "",
      billing_line4: "",
      billing_state: "",
      billing_postcode: "",
      billing_country: "CA",
      billing_phone_number: "",
      // products: [],
      products_set: false,
      product: [],
      // child_products: [],
      // parent_products: [],
      // child_products_urls: [],
      // child_products_urls_set: false,
      products: [],
      products_detail: [],
      temp_products_detail: [],
      parent_category: "",
      parent_products: [],
      parent_products_meta_data: [],
      children_products: [],
      children_products_detail: [],
      product_price: [],
      product_sku: [],
      product_availability: [],
      product_options: [],

      basket: [{}],
      basket_lines: [],
      same_as_shipping: false,
      submit_shipping: false,
      submit_billing: false,
      submit_delivery: false,
      submit_payment: false,
      continue_fedex_modal: false,
      shipping_methods: "",
      order_total_incl_tax: "",
      order_total_tax: "",
      promo_code_error: [],
      offers: [],
      vouchers: [],
      offers_set: false,
      userlang: ""
    };
  }

  componentDidMount = () => {
    const set_lang = window.document.getElementsByClassName("user-lang")[0];
    set_lang.addEventListener("click", this.set_user_language);

    if (this.cookiesEnabled() === 1) {
      this.get_offers();
      this.get_cart_basket();
      // getProducts()
      // .then((parent_products) => {
      //     // console.log(`parent products`, parent_products)
      //     this.setState({
      //         parent_products: parent_products
      //     })

      // })

      this.get_cbs_language_cookie();
    } else {
      alert(
        "To proceed to checkout, your web browser must have javascript and cookies enabled! / Pour passer à la caisse, les cookies doivent être activés sur votre navigateur Web"
      );
    }

    // userlang = cookies.get('cbs_language');
    // if (userlang) {
    //     this.setState({
    //         userlang
    //     });
    // }
    // this.get_available_shipping_methods();
    // console.log('Initial State', this.state);
  };

  componentDidUpdate = (prevProps, prevState) => {
    // console.log(this.state);
  };

  nextStep = () => {
    const { step } = this.state;
    this.setState({
      step: step + 1
    });
  };

  prevStep = () => {
    const { step } = this.state;
    this.setState({
      step: step - 1
    });
  };

  defaultStep = step => {
    this.setState({
      step: step
    });
  };

  disable_ship_button = state => {
    this.setState({
      submit_shipping: state
    });
  };

  disable_continue_modal = state => {
    this.setState({
      continue_fedex_modal: state
    });
  };

  disable_delivery_button = state => {
    this.setState({
      submit_delivery: state
    });
  };

  disable_billing_button = state => {
    this.setState({
      submit_billing: state
    });
  };

  disable_payment_button = state => {
    this.setState({
      submit_payment: state
    });
  };

  handleChange = input => event => {
    this.setState({ [input]: event.target.value });
  };

  handleChangeValidate = (line1, line2, city, state, postalCode) => {
    this.setState({
      shipping_line1: line1,
      shipping_line2: line2,
      shipping_line4: city,
      shipping_state: state,
      shipping_postcode: postalCode
    });
  };

  validate = () => {
    // console.log(`Validating Shipping Form .... `)

    let shipping_postcodeError = "";
    let shipping_first_nameError = "";
    let shipping_last_nameError = "";
    let shipping_line1Error = "";
    let shipping_line2Error = "";
    let shipping_line4Error = "";
    let shipping_stateError = "";
    let shipping_phone_numberError = "";
    let buzzerError = "";
    let guest_emailError = "";

    if (!this.state.shipping_first_name) {
      if (this.state.userlang === "fr") {
        shipping_first_nameError =
          '<li class="form__error">Ce champ est obligatoire.</li>';
        shipping_first_nameError = shipping_first_nameError.concat(
          '<li class="form__error">Inscrire un prénom valide.</li>'
        );
      } else {
        shipping_first_nameError =
          '<li class="form__error">This field is required.</li>';
        shipping_first_nameError = shipping_first_nameError.concat(
          '<li class="form__error">Please enter a valid first name.</li>'
        );
      }
    }

    if (!this.state.shipping_last_name) {
      if (this.state.userlang === "fr") {
        shipping_last_nameError =
          '<li class="form__error">Ce champ est obligatoire.</li>';
        shipping_last_nameError = shipping_last_nameError.concat(
          '<li class="form__error">Inscrire un nom valide..</li>'
        );
      } else {
        shipping_last_nameError =
          '<li class="form__error">This field is required.</li>';
        shipping_last_nameError = shipping_last_nameError.concat(
          '<li class="form__error">Please enter a valid last name.</li>'
        );
      }
    }

    if (!this.state.shipping_line1) {
      if (this.state.userlang === "fr") {
        shipping_line1Error =
          '<li class="form__error">Ce champ est obligatoire.</li>';
        shipping_line1Error = shipping_line1Error.concat(
          '<li class="form__error">Inscrire une adresse d’expédition valide.</li>'
        );
      } else {
        shipping_line1Error =
          '<li class="form__error">This field is required.</li>';
        shipping_line1Error = shipping_line1Error.concat(
          '<li class="form__error">Please enter a valid shipping address.</li>'
        );
      }
    }

    if (!this.state.shipping_line4) {
      if (this.state.userlang === "fr") {
        shipping_line4Error =
          '<li class="form__error">Ce champ est obligatoire.</li>';
        shipping_line4Error = shipping_line4Error.concat(
          '<li class="form__error">Inscrire un nom de ville valide.</li>'
        );
      } else {
        shipping_line4Error =
          '<li class="form__error">This field is required.</li>';
        shipping_line4Error = shipping_line4Error.concat(
          '<li class="form__error">Please enter a valid city.</li>'
        );
      }
    }

    if (!this.state.shipping_state) {
      if (this.state.userlang === "fr") {
        shipping_stateError =
          '<li class="form__error">Ce champ est obligatoire.</li>';
        shipping_stateError = shipping_stateError.concat(
          '<li class="form__error">Inscrire un nom de province valide.</li>'
        );
      } else {
        shipping_stateError =
          '<li class="form__error">This field is required.</li>';
        shipping_stateError = shipping_stateError.concat(
          '<li class="form__error">Please enter a valid province.</li>'
        );
      }
    }

    if (!this.state.shipping_phone_number) {
      if (this.state.userlang === "fr") {
        shipping_phone_numberError =
          '<li class="form__error">Ce champ est obligatoire.</li>';
        shipping_phone_numberError = shipping_phone_numberError.concat(
          '<li class="form__error">Inscrire un numéro de téléphone valide.</li>'
        );
      } else {
        shipping_phone_numberError =
          '<li class="form__error">This field is required.</li>';
        shipping_phone_numberError = shipping_phone_numberError.concat(
          '<li class="form__error">Please enter a valid phone number.</li>'
        );
      }
    }

    if (!this.state.guest_email) {
      if (this.state.userlang === "fr") {
        guest_emailError =
          '<li class="form__error">Ce champ est obligatoire.</li>';
        guest_emailError = guest_emailError.concat(
          '<li class="form__error">Inscrire une adresse courriel valide (p. ex. me@mydomain.com).</li>'
        );
      } else {
        guest_emailError =
          '<li class="form__error">This field is required.</li>';
        guest_emailError = guest_emailError.concat(
          '<li class="form__error">Please enter a valid email address (i.e. me@mydomain.com).</li>'
        );
      }
    } else {
      if (!isEmail(this.state.guest_email)) {
        guest_emailError = guest_emailError.concat(
          '<li class="form__error">Please enter a valid email address (i.e. me@mydomain.com).</li>'
        );
      }
    }

    if (this.state.shipping_line2 && !this.state.buzzer) {
      if (this.state.userlang === "fr") {
        buzzerError = '<li class="form__error">Ce champ est obligatoire.</li>';
        buzzerError = buzzerError.concat(
          '<li class="form__error">Inscrire le numéro de sonnette.</li>'
        );
      } else {
        buzzerError = '<li class="form__error">This field is required.</li>';
        buzzerError = buzzerError.concat(
          '<li class="form__error">Please enter your buzzer number.</li>'
        );
      }
    }

    // validatew postal code     [A-Za-z][0-9][A-Za-z] [0-9][A-Za-z][0-9]
    const postalCode = this.state.shipping_postcode.toUpperCase();
    if (!postcodeValidator(postalCode, "CA")) {
      if (this.state.userlang === "fr") {
        shipping_postcodeError =
          '<li class="form__error">Ce champ est obligatoire.</li>';
        shipping_postcodeError = shipping_postcodeError.concat(
          '<li class="form__error">Inscrire un code postal valide (p. ex. A1A 1B1).</li>'
        );
      } else {
        shipping_postcodeError =
          '<li class="form__error">Ce champ est obligatoire.</li>';
        shipping_postcodeError = shipping_postcodeError.concat(
          '<li class="form__error">Please enter a valid postal code (i.e. A1A 1B1)</li>'
        );
      }
    } else {
      document.getElementById("shipping_postcode_errors").innerHTML = "";
      const test = postalCode.substring(0, 3);
      if (invalid_postal_codes.includes(test)) {
        // console.log( test); // returns true
        // console.log(`Invalid test is ${invalid_postal_codes.includes( test )}`)
        if (this.state.userlang === "fr") {
          shipping_postcodeError =
            '<li class="form__error">Désolé, il n’est pas possible actuellement d’expédier un colis au code postal que vous avez inscrit.</li>';
        } else {
          shipping_postcodeError =
            '<li class="form__error">We are sorry, the postal code you have entered is not avalable for shipping at this time.</li>';
        }
      }
    }

    if (
      shipping_postcodeError ||
      shipping_first_nameError ||
      shipping_last_nameError ||
      shipping_phone_numberError ||
      shipping_line1Error ||
      shipping_line2Error ||
      shipping_line4Error ||
      shipping_stateError ||
      guest_emailError ||
      buzzerError
    ) {
      document.getElementById(
        "shipping_postcode_errors"
      ).innerHTML = shipping_postcodeError;
      document.getElementById(
        "shipping_first_name_errors"
      ).innerHTML = shipping_first_nameError;
      document.getElementById(
        "shipping_last_name_errors"
      ).innerHTML = shipping_last_nameError;
      document.getElementById(
        "shipping_line1_errors"
      ).innerHTML = shipping_line1Error;
      document.getElementById(
        "shipping_line2_errors"
      ).innerHTML = shipping_line2Error;
      document.getElementById(
        "shipping_line4_errors"
      ).innerHTML = shipping_line4Error;
      document.getElementById(
        "shipping_state_errors"
      ).innerHTML = shipping_stateError;
      document.getElementById(
        "shipping_phone_number_errors"
      ).innerHTML = shipping_phone_numberError;
      document.getElementById("buzzer_errors").innerHTML = buzzerError;
      document.getElementById(
        "guest_email_errors"
      ).innerHTML = guest_emailError;

      this.elScroll.executeScroll();
      return false;
    }
    return true;
  };

  validateBilling = () => {
    // console.log(`Validating Billing Form .... `)
    let billing_postcodeError = "";
    let billing_first_nameError = "";
    let billing_last_nameError = "";
    let billing_line1Error = "";
    let billing_line2Error = "";
    let billing_line4Error = "";
    let billing_stateError = "";
    let billing_phone_numberError = "";

    if (!this.state.billing_first_name) {
      if (this.state.userlang === "fr") {
        billing_first_nameError =
          '<li class="form__error">Ce champ est obligatoire.</li>';
        billing_first_nameError = billing_first_nameError.concat(
          '<li class="form__error">Inscrire un prénom valide.</li>'
        );
      } else {
        billing_first_nameError =
          '<li class="form__error">This field is required.</li>';
        billing_first_nameError = billing_first_nameError.concat(
          '<li class="form__error">Please enter a valid first name.</li>'
        );
      }
    }

    if (!this.state.billing_last_name) {
      if (this.state.userlang === "fr") {
        billing_last_nameError =
          '<li class="form__error">Ce champ est obligatoire.</li>';
        billing_last_nameError = billing_last_nameError.concat(
          '<li class="form__error">Inscrire un nom valide.</li>'
        );
      } else {
        billing_last_nameError =
          '<li class="form__error">This field is required.</li>';
        billing_last_nameError = billing_last_nameError.concat(
          '<li class="form__error">Please enter a valid last name.</li>'
        );
      }
    }

    if (!this.state.billing_line1) {
      if (this.state.userlang === "fr") {
        billing_line1Error =
          '<li class="form__error">Ce champ est obligatoire.</li>';
        billing_line1Error = billing_line1Error.concat(
          '<li class="form__error">Inscrire une adresse de facturation valide.</li>'
        );
      } else {
        billing_line1Error =
          '<li class="form__error">This field is required.</li>';
        billing_line1Error = billing_line1Error.concat(
          '<li class="form__error">Please enter a valid billing address.</li>'
        );
      }
    }

    if (!this.state.billing_line4) {
      if (this.state.userlang === "fr") {
        billing_line4Error =
          '<li class="form__error">Ce champ est obligatoire.</li>';
        billing_line4Error = billing_line4Error.concat(
          '<li class="form__error">Inscrire un nom valide.</li>'
        );
      } else {
        billing_line4Error =
          '<li class="form__error">This field is required.</li>';
        billing_line4Error = billing_line4Error.concat(
          '<li class="form__error">Please enter a valid city.</li>'
        );
      }
    }

    if (!this.state.billing_state) {
      if (this.state.userlang === "fr") {
        billing_stateError =
          '<li class="form__error">Ce champ est obligatoire.</li>';
        billing_stateError = billing_stateError.concat(
          '<li class="form__error">Inscrire un nom de province valide.</li>'
        );
      } else {
        billing_stateError =
          '<li class="form__error">This field is required.</li>';
        billing_stateError = billing_stateError.concat(
          '<li class="form__error">Please enter a valid province.</li>'
        );
      }
    }

    if (!this.state.billing_phone_number) {
      if (this.state.userlang === "fr") {
        billing_phone_numberError =
          '<li class="form__error">Ce champ est obligatoire.</li>';
        billing_phone_numberError = billing_phone_numberError.concat(
          '<li class="form__error">Inscrire un numéro de téléphone valide.</li>'
        );
      } else {
        billing_phone_numberError =
          '<li class="form__error">This field is required.</li>';
        billing_phone_numberError = billing_phone_numberError.concat(
          '<li class="form__error">Please enter a valid phone number.</li>'
        );
      }
    }

    // validatew postal code     [A-Za-z][0-9][A-Za-z] [0-9][A-Za-z][0-9]
    const postalCode = this.state.billing_postcode.toUpperCase();
    if (!postcodeValidator(postalCode, "CA")) {
      if (this.state.userlang === "fr") {
        billing_postcodeError =
          '<li class="form__error">Ce champ est obligatoire.</li>';
        billing_postcodeError = billing_postcodeError.concat(
          '<li class="form__error">Inscrire un code postal valide (p. ex. A1A 1B1).</li>'
        );
      } else {
        billing_postcodeError =
          '<li class="form__error">This field is required.</li>';
        billing_postcodeError = billing_postcodeError.concat(
          '<li class="form__error">Please enter a valid postal code (i.e. A1A 1B1)</li>'
        );
      }
    }

    if (
      billing_postcodeError ||
      billing_first_nameError ||
      billing_last_nameError ||
      billing_phone_numberError ||
      billing_line1Error ||
      billing_line2Error ||
      billing_line4Error ||
      billing_stateError
    ) {
      document.getElementById(
        "billing_postcode_errors"
      ).innerHTML = billing_postcodeError;
      document.getElementById(
        "billing_first_name_errors"
      ).innerHTML = billing_first_nameError;
      document.getElementById(
        "billing_last_name_errors"
      ).innerHTML = billing_last_nameError;
      document.getElementById(
        "billing_line1_errors"
      ).innerHTML = billing_line1Error;
      document.getElementById(
        "billing_line2_errors"
      ).innerHTML = billing_line2Error;
      document.getElementById(
        "billing_line4_errors"
      ).innerHTML = billing_line4Error;
      document.getElementById(
        "billing_state_errors"
      ).innerHTML = billing_stateError;
      document.getElementById(
        "billing_phone_number_errors"
      ).innerHTML = billing_phone_numberError;

      this.elScroll.executeScroll();
      return false;
    }
    return true;
  };

  handle_billing_address = e => {
    // console.log(`Same as Shipping Address `, e.target.checked);

    this.setState({
      same_as_shipping: e.target.checked
    });

    if (e.target.checked === true) {
      const shippingInfo =
        "<div>" +
        this.state.shipping_first_name +
        " " +
        this.state.shipping_last_name +
        "<br />" +
        this.state.shipping_line1 +
        "<br /><div>" +
        this.state.shipping_line2 +
        "</div>" +
        this.state.shipping_line4 +
        ", " +
        this.state.shipping_state +
        " " +
        this.state.shipping_postcode +
        "<br />" +
        this.state.shipping_phone_number +
        "<br /></div>";

      // console.log(`Billing Address Info `, shippingInfo);
      document.getElementById(
        "checkout-step__summary-address-shipping-b"
      ).innerHTML = shippingInfo;
      document.getElementById(
        "checkout-step__summary-address-billing"
      ).innerHTML = shippingInfo;
    }
  };

  // get_available_shipping_methods = () => {
  //     const url = `${BASE_URL}/api/basket/shipping-methods/`;
  //     fetchData(url)
  //     .then( (data) => {
  //         console.log(`Available Shipping Methods`, data);
  //         this.setState({
  //             shipping_methods: data
  //         });
  //     })
  // }

  set_shipping_method = method => {
    // this.setState({
    //     shipping_methods: method
    // });
  };

  fetch_tax = () => {
    // http://dev.cocoonsealy.net/api/checkout/fetch-tax/
    const url = `${BASE_URL}/api/checkout/fetch-tax/`;
    fetchData(url).then(data => {
      // console.log(`Available Shipping Methods`, data);
      this.setState({
        order_total_incl_tax: data.total_incl_tax,
        order_total_tax: data.tax
      });
    });
  };

  get_cart_basket = () => {
    getCartProducts()
      .then(data => {
        this.setState(
          {
            basket: data
          },
          () => {
            // console.log(`New State `, this.state)
            this.get_voucher_savings(this.state);
            this.get_offer_savings(this.state);
          }
        );

        return data;
      })
      .then(data => {
        // console.log(`---------------------------- getting cart Basket ----------------------------------`, data)
        this.get_basket_lines(data.lines);
      });
  };

  get_basket_lines = url => {
    // console.log(`+++++++++++==================+===++==++ Get Basket Basket Lines ++========++++++++=+======+===`, url);
    // console.log(`+++++++++++==================+===++==+++++++++++++++ Basket ++========++++++++=+======+===`, this.state.basket);
    let products = [];
    fetchData(url)
      .then(res => {
        this.setState({
          num_of_products: res.length,
          basket_lines: res
        });
        return res;
      })

      .then(res => {});
  };

  display_offer_content = (quantity, index, data) => {
    let offer;
    if (data.type === 1) {
      offer = (
        <div
          className="basket-line-savings__details accordion-target accordionTarget"
          data-id={"b" + index}
          onClick={this.show_savings}
        >
          <div className="basket-line-savings__detail">
            <div className="basket-line-savings__title basket-line-savings__detail-title">
              {data.savingsName}
            </div>
            <div className="basket-line-savings__total basket-line-savings__detail-total">
              -$
              {parseFloat(
                this.state.basket_lines[index].price_excl_tax_excl_discounts
              ) - parseFloat(this.state.basket_lines[index].price_excl_tax)}
            </div>
          </div>
        </div>
      );

      return offer;
    } else {
      offer = (
        <div
          className="basket-line-savings__details accordion-target accordionTarget"
          data-id={"b" + index}
          onClick={this.show_savings}
        >
          <div className="basket-line-savings__detail">
            <div className="basket-line-savings__title basket-line-savings__detail-title">
              {data.savingsName}
            </div>
            <div className="basket-line-savings__total basket-line-savings__detail-total">
              -$
              {parseFloat(
                this.state.basket_lines[index].price_excl_tax_excl_discounts
              ) - parseFloat(this.state.basket_lines[index].price_excl_tax)}
            </div>
          </div>
        </div>
      );

      return offer;
    }
  };

  discount_type = amount => {
    let type;
    let savings = this.state.basket.offer_discounts;
    let discountName;
    // console.log(`$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$ Amount $$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$`, amount.toFixed(2));
    savings = savings.filter(
      item => parseFloat(item.amount).toFixed(2) === amount.toFixed(2)
    );

    if (savings.length > 0) {
      // console.log(`@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ savings Initial Offer @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@`, savings);
      type = 1;
      discountName = savings[0].name;
      // console.log(`@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ savings @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@`, savings);
      return { type: type, savingsName: discountName };
    } else if (this.state.basket.voucher_discounts.length > 0) {
      savings = this.state.basket.voucher_discounts;
      // console.log(`@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ savings Initial Coupon @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@`, savings);
      savings = savings.filter(
        item => parseFloat(item.amount).toFixed(2) === amount.toFixed(2)
      );
      type = 2;
      discountName = savings[0].voucher.name;
      // console.log(`@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ savings @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@`, savings);
      return { type: type, savingsName: discountName };
    } else {
      return { type: 0, savingsName: "" };
    }
  };

  get_offer_savings = _State => {
    const element = document.getElementById("offner-name");
    // console.log(`Basket State`, this.state)
    // console.log(`Basket _State`, _State)
    if (
      this.state.basket === undefined ||
      _State.basket.offer_discounts.length === 0
    ) {
      return "";
    } else {
      element.innerHTML = _State.basket.offer_discounts[0].name;
    }
  };

  get_voucher_savings = _State => {
    const element = document.getElementById("voucher-name");
    // console.log(`Basket State`, this.state)
    // console.log(`Basket _State`, _State)
    if (
      this.state.basket === undefined ||
      _State.basket.voucher_discounts.length === 0
    ) {
      return "";
    } else {
      // return this.basket.voucher_discounts[0].voucher.name;
      element.innerHTML = _State.basket.voucher_discounts[0].voucher.name;
    }
  };

  // get active discount offers  & vouchers i.e coupons
  get_offers = () => {
    if (this.state.offers_set === false) {
      getOffers().then(data => {
        this.setState({
          offers: data.offers,
          vouchers: data.vouchers,
          offers_set: true
        });
      });
    }
  };

  get_cbs_language_cookie = () => {
    get_user_lang().then(data => {
      // console.log('User language is ... ',data);
      if (data.userlang !== undefined) {
        userlang = data.userlang;
        this.setState({
          userlang
        });
      }
    });
  };

  cookiesEnabled = () => {
    let i, j, cookies, found;
    document.cookie = "testcookiesenabled=1";
    for (i = 0; i < 2; i++) {
      found = false;
      cookies = document.cookie.split(";");
      j = cookies.length;
      while (j--) {
        while (cookies[j].charAt(0) === " ") {
          // trim spaces
          cookies[j] = cookies[j].substring(1);
        }
        if (cookies[j].indexOf("testcookiesenabled=") === 0) {
          found = true;
          break;
        }
      }
      if (!found) {
        return i;
      }
      // Delete test cookie.
      document.cookie =
        "testcookiesenabled=; expires=Thu, 01 Jan 1970 00:00:01 GMT";
    }
    // Results inconclusive.
  };

  add_promo_code = () => {
    // update product in cart basket
    const code = document.getElementById("checkout-promo-code").value;
    let elementError = [];
    this.setState({
      promo_code_error: elementError
    });

    // console.log(`add promo code in basket: `, code);
    // const csrftoken = cookies.get('csrftoken');
    addPromocode(code, csrftoken).then(res => {
      // if response code is 200 voucher is successful
      // console.log(`====>>>>>>>>>>>>>>>>>>>>>>> add promo code result: `, res);
      if (res !== undefined || res !== "") {
        // call basket items and mini
        // this.get_cart_basket();
        if (
          res.vouchercode !== undefined &&
          res.vouchercode[0] === "This field may not be blank."
        ) {
          // console.log(`====>>>>>>>>>>>>>>>>>>>>>>> add promo code Error: `, res.vouchercode[0]);
          elementError = elementError.concat(
            <li className="form__error">{res.vouchercode[0]}</li>
          );
          this.setState({
            promo_code_error: elementError
          });
        } else if (
          res.non_field_errors !== undefined &&
          res.non_field_errors[0] === "Voucher code unknown"
        ) {
          // console.log(`====>>>>>>>>>>>>>>>>>>>>>>> add promo code Error: `, res.non_field_errors[0]);
          res.non_field_errors[0] = "Invalid promo code; please try again.";
          elementError = elementError.concat(
            <li className="form__error">{res.non_field_errors[0]}</li>
          );
          this.setState({
            promo_code_error: elementError
          });
        } else if (
          res.non_field_errors !== undefined &&
          res.non_field_errors[0].match(/expired/g)
        ) {
          // console.log(`====>>>>>>>>>>>>>>>>>>>>>>> add promo code Error: `, res.non_field_errors[0]);
          elementError = elementError.concat(
            <li className="form__error">{res.non_field_errors[0]}</li>
          );
          this.setState({
            promo_code_error: elementError
          });
        } else if (
          res.reason !== undefined &&
          res.reason === "Your cart does not qualify for a coupon discount"
        ) {
          // console.log(`====>>>>>>>>>>>>>>>>>>>>>>> add promo code Error: `, res.reason);
          elementError = elementError.concat(
            <li className="form__error">{res.reason}</li>
          );
          this.setState({
            promo_code_error: elementError
          });
        } else {
          this.setState({
            promo_code_error: elementError
          });
          this.get_cart_basket();
        }
      }
    });
  };

  get_child_products = () => {
    let products = [];
    if (this.state.parent_products.length > 0) {
      // console.log(`Checkout state`, this.state);
      this.getChildProductUrls();
    }

    if (
      this.state.child_products_urls_set === true &&
      this.state.products_set === false
    ) {
      let results = [];
      const urls = this.state.child_products_urls;

      for (let [key, pvalue] of Object.entries(urls)) {
        results[key] = fetchData(pvalue.url);
      }

      axios
        .all(results)
        .then(
          axios.spread(function(
            results_1,
            results_2,
            results_3,
            results_4,
            results_5,
            results_6,
            results_7,
            results_8,
            results_9,
            results_10,
            results_11,
            results_12,
            results_13,
            results_14,
            results_15
          ) {
            // console.log(`Processing Child Products`);
            products = products.concat(results_1);
            products = products.concat(results_2);
            products = products.concat(results_3);
            products = products.concat(results_4);
            products = products.concat(results_5);
            products = products.concat(results_6);
            products = products.concat(results_7);
            products = products.concat(results_8);
            products = products.concat(results_9);
            products = products.concat(results_10);
            products = products.concat(results_11);
            products = products.concat(results_12);
            products = products.concat(results_13);
            products = products.concat(results_14);
            products = products.concat(results_15);

            return products;
          })
        )

        .then(data => {
          // console.log(`products`, data);

          this.setState({
            products: data,
            products_set: true
          });
        });
    }
  };

  getChildProductUrls = () => {
    const urls = this.state.parent_products;
    let results = [];
    let childUrls = [];

    if (this.state.child_products_urls_set === false) {
      for (let [key, pvalue] of Object.entries(urls)) {
        results[key] = fetchData(pvalue.url);
      }

      axios
        .all(results)
        .then(
          axios.spread(function(resultsA, resultsB) {
            // Both requests are now complete
            // console.log(`Processing Child Urls`);
            // console.log(resultsA);
            // console.log(resultsB);

            let item_categoryB;
            let item_categoryA;

            if (resultsA.title === "Essential Medium") {
              item_categoryA = "cocoon-essential";
            }

            if (resultsB.title === "Cocoon Classic") {
              item_categoryB = "cocoon-classic";
            }

            for (let [key, value] of Object.entries(resultsA.children)) {
              // console.log(`${key}: ${value}`);
              childUrls = childUrls.concat({
                url: value.url,
                parent_id: resultsA.id,
                category: item_categoryA
              });
            }

            for (let [key, value] of Object.entries(resultsB.children)) {
              // console.log(`${key}: ${value}`);
              childUrls = childUrls.concat({
                url: value.url,
                parent_id: resultsB.id,
                category: item_categoryB
              });
            }

            // return childUrls;
          })
        )

        .then(data => {
          this.setState({
            child_products_urls: childUrls,
            child_products_urls_set: true
          });
        });
    }
  };

  get_product_url = url => {
    const title = this.get_product_title(url);
    let product_url;

    if (title.match(/Cocoon Classic/g)) {
      product_url = "/mattress/classic/purchase/";
    } else if (title.match(/Cocoon Essential/g)) {
      product_url = "/mattress/essential/purchase/";
    } else if (title.match(/Sealy Premium/g)) {
      product_url = "/pillows/premium-pillow/";
    } else if (title.match(/Sealy Performance/g)) {
      product_url = "/pillows/performance-pillow/";
    } else if (title.match(/Sealy Essential/g)) {
      product_url = "/pillows/essentials-pillow/";
    }

    return product_url;
  };

  // get_product_category = (title) => {
  //     let product_category;
  //     title = this.get_product_title(title);

  //     if (title.match(/Cocoon Classic/g)) {
  //         product_category = 'cocoon-classic';
  //     } else if (title.match(/Cocoon Essential/g)) {
  //         product_category = 'cocoon-essential';
  //     } else if (title.match(/Sealy Premium/g)) {
  //         product_category = 'sealy-premium';
  //     } else if (title.match(/Sealy Performance/g)) {
  //         product_category = 'sealy-performance';
  //     } else if (title.match(/Sealy Essential/g)) {
  //         product_category = 'sealy-essential';
  //     }

  //     return product_category;
  // }

  get_product_category = url => {
    // console.log(`Product Category URL (Basket Page)`, url);
    let product_category;
    const title = this.get_product_title(url);

    if (title.match(/Cocoon Classic/g)) {
      product_category = "cocoon-classic";
    } else if (title.match(/Essential Medium/g)) {
      product_category = "cocoon-essential";
    } else if (title.match(/Sealy Premium/g)) {
      product_category = "sealy-premium";
    } else if (title.match(/Sealy Performance/g)) {
      product_category = "sealy-performance";
    } else if (title.match(/Sealy Essential/g)) {
      product_category = "sealy-essential";
    }

    // console.log(`Product Category (Basket Page) "${product_category}"`);

    return product_category;
  };

  // get_product_title = (url) => {
  //     // console.log(`+++++++++++==================+===++==+++++++++++++++ Basket Product Url ++========++++++++=+======+===`, url);
  //     // console.log(`+++++++++++==================+===++==+++++++++++++++ Basket (state) ++========++++++++=+======+===`, this.state);
  //     let product = this.state.products;
  //     if (product.filter(item => item.url === url)){
  //         // console.log(product);
  //         if (this.state.products.length === 15) {
  //             // console.log(`+++++++++++==================+===++==+++++++++++++++ Basket Products ++========++++++++=+======+===`, this.state.child_products);
  //             product = product.filter(item => item.url === url);
  //             // console.log(`+++++++++++==================+===++==+++++++++++++++ Basket Product ++========++++++++=+======+===`, product);
  //             const title = product[0].title;
  //             // console.log(`+++++++++++==================+===++==+++++++++++++++ Basket Product Title ++========++++++++=+======+===`, title);
  //             return title;
  //         }else{
  //             return "No Title";
  //         }
  //     }else{
  //         return "No Title";
  //     }

  // }

  get_product_title = url => {
    // console.log(`+++++++++++==================+===++==+++++++++++++++ Basket Page Product Url ++========++++++++=+======+===`, url);
    // console.log(`+++++++++++==================+===++==+++++++++++++++ MiniBasket ++========++++++++=+======+===`, this.state);

    let title = "";
    let product = this.state.products;
    let child_products = this.state.children_products_detail;
    // console.log(`+++++++++++==================+===++==+++++++++++++++ Basket Page Products ++========++++++++=+======+===`, product);
    // console.log(`+++++++++++==================+===++==+++++++++++++++ Basket Page Child Products ++========++++++++=+======+===`, child_products);
    if (
      window.location.pathname === "/en/store/basket/" ||
      window.location.pathname === "/fr/store/basket/"
    ) {
      // title = window.Basket.get_product_title(url)
      // console.log(`+++++++++++==================+===++==+++++++++++++++ MiniBasket Products ++========++++++++=+======+===`, this.state.products);
      product = product.filter(item => item.url === url);
      // console.log(`+++++++++++==================+===++==+++++++++++++++ Basket Page Product 1 ++========++++++++=+======+===`, product);
      if (product === undefined || product.length === 0) {
        product = child_products.filter(item => item.url === url);
      }
      // console.log(`+++++++++++==================+===++==+++++++++++++++ Basket Page Product 2 ++========++++++++=+======+===`, product);
      title = product[0].title;
    } else {
      // console.log(`+++++++++++==================+===++==+++++++++++++++ MiniBasket Products ++========++++++++=+======+===`, this.state.products);
      product = product.filter(item => item.url === url);
      // console.log(`+++++++++++==================+===++==+++++++++++++++ Basket Page Product 3 ++========++++++++=+======+===`, product);
      if (product === undefined || product.length === 0) {
        product = child_products.filter(item => item.url === url);
      }

      // console.log(`+++++++++++==================+===++==+++++++++++++++ Basket Page Product 4 ++========++++++++=+======+===`, product);

      title = product[0].title;
    }
    // console.log(`+++++++++++==================+===++==+++++++++++++++ MiniBasket Product Title ++========++++++++=+======+===`, title);
    return title;
  };

  match_mattress_size = title => {
    let mattress_size = "";

    if (title.match(/King/g)) {
      // alert("FUCK YEAH Title: " + childProducts.title + " ID" + childProducts.id);
      mattress_size = "King";
    } else if (title.match(/Queen/g)) {
      // alert("FUCK YEAH Title: " + childProducts.title + " ID" + childProducts.id);
      mattress_size = "Queen";
    } else if (title.match(/Full/g)) {
      // alert("FUCK YEAH Title: " + childProducts.title + " ID" + childProducts.id);
      mattress_size = "Full";
    } else if (title.match(/Twin/g) && !title.match(/XL/g)) {
      // alert("FUCK YEAH Title: " + childProducts.title + " ID" + childProducts.id);
      mattress_size = "Twin";
    } else if (title.match(/XL/g) && title.match(/Twin/g)) {
      // alert("FUCK YEAH Title: " + childProducts.title + " ID" + childProducts.id);
      mattress_size = "Twin XL";
    }
    return mattress_size;
  };

  match_mattress_comfort = title => {
    let comfort = "";
    if (title.match(/Soft/g)) {
      // alert("FUCK YEAH Soft Title: " + childProducts.title + " ID" + childProducts.id);
      comfort = "Soft";
    } else if (title.match(/Firm/g)) {
      // alert("FUCK YEAH Firm Title: " + childProducts.title + " ID" + childProducts.id);
      comfort = "Firm";
    } else if (title.match(/Medium/g)) {
      // alert("FUCK YEAH Medium Title: " + childProducts.title + " ID" + childProducts.id);
      comfort = "Medium";
    }

    return comfort;
  };

  is_basket_empty = () => {
    // console.log(`Basket Is Not Empty`)
  };

  set_user_language = e => {
    e.preventDefault();
    // console.log('Now Send form');
    const form = window.document.getElementById("userlang");
    form.submit();
  };

  /* // initializing product data */

  init_products_details_temp = products_detail => {
    // console.log(`Sent in products detail`, products_detail);
    this.setState({
      temp_products_detail: this.state.temp_products_detail.concat(
        products_detail
      )
    });
  };

  init_products_details = products_detail => {
    // console.log(`Finalizing products detail`, products_detail);
    this.setState({
      products_detail
    });
  };

  init_products = products => {
    this.setState({
      products
    });
  };

  init_product_meta = metadata => {
    this.setState({
      parent_products_meta_data: metadata
    });
  };

  set_product_sku = (product_sku, product_id) => {
    const data = { sku: product_sku, id: product_id };
    this.setState({
      product_sku: this.state.product_sku.concat(data)
    });
  };

  set_product_price = (product_price, product_id) => {
    // console.log(`Product Price: `, product_price);
    const data = { price: product_price, id: product_id };
    this.setState({
      product_price: this.state.product_price.concat(data)
    });
  };

  set_product_availability = (product_availability, product_id) => {
    const data = { availability: product_availability, id: product_id };
    this.setState({
      product_availability: this.state.product_availability.concat(data)
    });
  };

  set_child_products = children_products => {
    this.setState({
      children_products: this.state.children_products.concat(children_products)
    });
  };

  set_child_products_detail = children_products_detail => {
    this.setState({
      children_products_detail: this.state.children_products_detail.concat(
        children_products_detail
      )
    });
  };

  set_product_options = options => {
    this.setState({
      product_options: this.state.product_options.concat(options)
    });
  };

  set_default_products = default_products => {
    // console.log(`Setting Default product: `, default_products);
    this.setState({
      default_products
    });
  };

  set_new_current_product = new_current_product => {
    // console.log(`Setting New Current product: `, new_current_product);
    this.setState({
      new_current_product
    });
  };

  render() {
    const { step } = this.state;
    const promo_code_error = this.state.promo_code_error;
    const {
      shipping_first_name,
      shipping_last_name,
      shipping_line1,
      shipping_line2,
      shipping_line4,
      shipping_state,
      shipping_postcode,
      shipping_country,
      shipping_phone_number,
      buzzer,
      guest_email,
      shipping_method_0,
      shipping_notes,
      billing_first_name,
      billing_last_name,
      billing_line1,
      billing_line2,
      billing_line4,
      billing_state,
      billing_postcode,
      billing_country,
      billing_phone_number
    } = this.state;
    const values = {
      shipping_first_name,
      shipping_last_name,
      shipping_line1,
      shipping_line2,
      shipping_line4,
      shipping_state,
      shipping_postcode,
      shipping_country,
      shipping_phone_number,
      buzzer,
      guest_email,
      shipping_method_0,
      shipping_notes,
      billing_first_name,
      billing_last_name,
      billing_line1,
      billing_line2,
      billing_line4,
      billing_state,
      billing_postcode,
      billing_country,
      billing_phone_number
    };

    switch (step) {
      case 1:
        return (
          <React.Fragment>
            {/* <!-- Start of Checkout Page --> */}
            <div>
              <div
                ref={this.elScroll.htmlElRef}
                className="checkout__react-container"
              >
                {/* <!-- Left Column --> */}
                <div className="checkout__column--left">
                  <Shipping
                    nextStep={this.nextStep}
                    handleChange={this.handleChange}
                    handleChangeValidate={this.handleChangeValidate}
                    values={values}
                    step={this.state.step}
                    submit_shipping={this.state.submit_shipping}
                    disable_ship_button={this.disable_ship_button}
                    continue_fedex_modal={this.state.continue_fedex_modal}
                    disable_continue_modal={this.disable_continue_modal}
                    disable_billing_button={this.disable_billing_button}
                    disable_delivery_button={this.disable_delivery_button}
                    disable_ship_button={this.disable_ship_button}
                    validate={this.validate}
                    shipping_postcodeError={this.state.shipping_postcodeError}
                    shipping_first_nameError={
                      this.state.shipping_first_nameError
                    }
                    shipping_last_nameError={this.state.shipping_last_nameError}
                    shipping_line1Error={this.state.shipping_line1Error}
                    shipping_line2Error={this.state.shipping_line2Error}
                    shipping_line4Error={this.state.shipping_line4Error}
                    shipping_stateError={this.state.shipping_stateError}
                    shipping_phone_numberError={
                      this.state.shipping_phone_numberError
                    }
                    buzzerError={this.state.buzzerError}
                    guest_emailError={this.state.guest_emailError}
                    get_child_products={this.get_child_products}
                    userlang={this.state.userlang}
                    get_cbs_language_cookie={this.get_cbs_language_cookie}
                  />
                  <Products
                    init_products={this.init_products}
                    products={this.state.products}
                    init_products_details_temp={this.init_products_details_temp}
                    products_detail_temp={this.state.temp_products_detail}
                    init_products_details={this.init_products_details}
                    products_detail={this.state.products_detail}
                    init_product_meta={this.init_product_meta}
                    set_child_products={this.set_child_products}
                    set_child_products_detail={this.set_child_products_detail}
                    children_products_detail={
                      this.state.children_products_detail
                    }
                    set_product_options={this.set_product_options}
                    set_product_sku={this.set_product_sku}
                    set_product_availability={this.set_product_availability}
                    set_product_price={this.set_product_price}
                    default_products={this.state.default_products}
                    parent_products_meta_data={
                      this.state.parent_products_meta_data
                    }
                  />
                </div>
                {/* <!--End of Left Column -->*/}
                {/*<!-- Right Coliumn --> */}
                <Ordersummary
                  basket={this.state.basket}
                  basket_lines={this.state.basket_lines}
                  order_total_incl_tax={this.state.order_total_incl_tax}
                  order_total_tax={this.state.order_total_tax}
                  step={this.state.step}
                  add_promo_code={this.add_promo_code}
                  promo_code_error={promo_code_error}
                  userlang={this.state.userlang}
                />
                {/* <!-- End of Right Coliumn --> */}
              </div>
            </div>
            {/* <!-- end of check page --></div> */}
          </React.Fragment>
        );

      case 2:
        return (
          <React.Fragment>
            {/* <!-- Start of Checkout Page --> */}
            <div>
              <div
                ref={this.elScroll.htmlElRef}
                className="checkout__react-container"
              >
                {/* <!-- Left Column --> */}
                <div className="checkout__column--left">
                  <Shipping
                    nextStep={this.nextStep}
                    prevStep={this.prevStep}
                    handleChange={this.handleChange}
                    values={values}
                    step={this.state.step}
                    disable_billing_button={this.disable_billing_button}
                    disable_delivery_button={this.disable_delivery_button}
                    disable_ship_button={this.disable_ship_button}
                    userlang={this.state.userlang}
                    get_cbs_language_cookie={this.get_cbs_language_cookie}
                  />
                  <Delivery
                    prevStep={this.prevStep}
                    nextStep={this.nextStep}
                    handleChange={this.handleChange}
                    values={values}
                    step={this.state.step}
                    set_shipping_method={this.set_shipping_method()}
                    submit_delivery={this.state.submit_delivery}
                    disable_billing_button={this.disable_billing_button}
                    disable_delivery_button={this.disable_delivery_button}
                    disable_ship_button={this.disable_ship_button}
                    products={this.state.products}
                    basket_lines={this.state.basket_lines}
                    get_product_category={this.get_product_category}
                    get_product_title={this.get_product_title}
                    get_product_url={this.get_product_url}
                    userlang={this.state.userlang}
                    get_cbs_language_cookie={this.get_cbs_language_cookie}
                  />
                  <Products
                    init_products={this.init_products}
                    products={this.state.products}
                    init_products_details_temp={this.init_products_details_temp}
                    products_detail_temp={this.state.temp_products_detail}
                    init_products_details={this.init_products_details}
                    products_detail={this.state.products_detail}
                    init_product_meta={this.init_product_meta}
                    set_child_products={this.set_child_products}
                    set_child_products_detail={this.set_child_products_detail}
                    children_products_detail={
                      this.state.children_products_detail
                    }
                    set_product_options={this.set_product_options}
                    set_product_sku={this.set_product_sku}
                    set_product_availability={this.set_product_availability}
                    set_product_price={this.set_product_price}
                    default_products={this.state.default_products}
                    parent_products_meta_data={
                      this.state.parent_products_meta_data
                    }
                  />
                </div>
                {/* <!--End of Left Column -->*/}
                {/*<!-- Right Coliumn --> */}
                <Ordersummary
                  basket={this.state.basket}
                  basket_lines={this.state.basket_lines}
                  order_total_incl_tax={this.state.order_total_incl_tax}
                  order_total_tax={this.state.order_total_tax}
                  step={this.state.step}
                  add_promo_code={this.add_promo_code}
                  promo_code_error={promo_code_error}
                  userlang={this.state.userlang}
                />
                {/* <!-- End of Right Coliumn --> */}
              </div>
            </div>
            {/* <!-- end of check page --></div> */}
          </React.Fragment>
        );
      case 3:
        return (
          <React.Fragment>
            {/* <!-- Start of Checkout Page --> */}
            <div>
              <div
                ref={this.elScroll.htmlElRef}
                className="checkout__react-container"
              >
                {/* <!-- Left Column --> */}
                <div className="checkout__column--left">
                  <Shipping
                    nextStep={this.nextStep}
                    prevStep={this.prevStep}
                    handleChange={this.handleChange}
                    values={values}
                    step={this.state.step}
                    defaultStep={this.defaultStep}
                    disable_billing_button={this.disable_billing_button}
                    disable_delivery_button={this.disable_delivery_button}
                    disable_ship_button={this.disable_ship_button}
                    userlang={this.state.userlang}
                    get_cbs_language_cookie={this.get_cbs_language_cookie}
                  />
                  <Delivery
                    prevStep={this.prevStep}
                    nextStep={this.nextStep}
                    handleChange={this.handleChange}
                    values={values}
                    step={this.state.step}
                    set_shipping_method={this.set_shipping_method()}
                    disable_billing_button={this.disable_billing_button}
                    disable_delivery_button={this.disable_delivery_button}
                    disable_ship_button={this.disable_ship_button}
                    products={this.state.products}
                    basket_lines={this.state.basket_lines}
                    get_product_category={this.get_product_category}
                    get_product_title={this.get_product_title}
                    get_product_url={this.get_product_url}
                    userlang={this.state.userlang}
                    get_cbs_language_cookie={this.get_cbs_language_cookie}
                  />
                  <Billing
                    nextStep={this.nextStep}
                    prevStep={this.prevStep}
                    handleChange={this.handleChange}
                    values={values}
                    same_as_shipping={this.state.same_as_shipping}
                    step={this.state.step}
                    handle_billing_address={this.handle_billing_address}
                    submit_billing={this.state.submit_billing}
                    disable_billing_button={this.disable_billing_button}
                    disable_delivery_button={this.disable_delivery_button}
                    disable_ship_button={this.disable_ship_button}
                    validate={this.validateBilling}
                    get_cart_basket={this.get_cart_basket}
                    fetch_tax={this.fetch_tax}
                    userlang={this.state.userlang}
                    get_cbs_language_cookie={this.get_cbs_language_cookie}
                  />
                  <Products
                    init_products={this.init_products}
                    products={this.state.products}
                    init_products_details_temp={this.init_products_details_temp}
                    products_detail_temp={this.state.temp_products_detail}
                    init_products_details={this.init_products_details}
                    products_detail={this.state.products_detail}
                    init_product_meta={this.init_product_meta}
                    set_child_products={this.set_child_products}
                    set_child_products_detail={this.set_child_products_detail}
                    children_products_detail={
                      this.state.children_products_detail
                    }
                    set_product_options={this.set_product_options}
                    set_product_sku={this.set_product_sku}
                    set_product_availability={this.set_product_availability}
                    set_product_price={this.set_product_price}
                    default_products={this.state.default_products}
                    parent_products_meta_data={
                      this.state.parent_products_meta_data
                    }
                  />
                </div>
                {/* <!--End of Left Column -->*/}
                {/*<!-- Right Coliumn --> */}
                <Ordersummary
                  basket={this.state.basket}
                  basket_lines={this.state.basket_lines}
                  order_total_incl_tax={this.state.order_total_incl_tax}
                  order_total_tax={this.state.order_total_tax}
                  step={this.state.step}
                  add_promo_code={this.add_promo_code}
                  promo_code_error={promo_code_error}
                  userlang={this.state.userlang}
                />
                {/* <!-- End of Right Coliumn --> */}
              </div>
            </div>
            {/* <!-- end of check page --></div> */}
          </React.Fragment>
        );
      case 4:
        return (
          <React.Fragment>
            {/* <!-- Start of Checkout Page --> */}
            <div>
              <div className="checkout__react-container">
                {/* <!-- Left Column --> */}
                <div className="checkout__column--left">
                  <Shipping
                    nextStep={this.nextStep}
                    prevStep={this.prevStep}
                    handleChange={this.handleChange}
                    values={values}
                    step={this.state.step}
                    defaultStep={this.defaultStep}
                    disable_billing_button={this.disable_billing_button}
                    disable_delivery_button={this.disable_delivery_button}
                    disable_ship_button={this.disable_ship_button}
                    userlang={this.state.userlang}
                    get_cbs_language_cookie={this.get_cbs_language_cookie}
                  />
                  <Delivery
                    prevStep={this.prevStep}
                    nextStep={this.nextStep}
                    handleChange={this.handleChange}
                    values={values}
                    step={this.state.step}
                    defaultStep={this.defaultStep}
                    set_shipping_method={this.set_shipping_method()}
                    disable_billing_button={this.disable_billing_button}
                    disable_delivery_button={this.disable_delivery_button}
                    disable_ship_button={this.disable_ship_button}
                    basket_lines={this.state.basket_lines}
                    products={this.state.products}
                    get_product_category={this.get_product_category}
                    get_product_title={this.get_product_title}
                    get_product_url={this.get_product_url}
                    userlang={this.state.userlang}
                    get_cbs_language_cookie={this.get_cbs_language_cookie}
                  />
                  <Billing
                    nextStep={this.nextStep}
                    prevStep={this.prevStep}
                    handleChange={this.handleChange}
                    values={values}
                    same_as_shipping={this.state.same_as_shipping}
                    step={this.state.step}
                    defaultStep={this.defaultStep}
                    disable_billing_button={this.disable_billing_button}
                    disable_delivery_button={this.disable_delivery_button}
                    disable_ship_button={this.disable_ship_button}
                    userlang={this.state.userlang}
                    get_cbs_language_cookie={this.get_cbs_language_cookie}
                    get_cart_basket={this.get_cart_basket}
                    fetch_tax={this.fetch_tax}
                  />
                  <Payment
                    same_as_shipping={this.state.same_as_shipping}
                    disable_payment_button={this.disable_payment_button}
                    submit_payment={this.state.submit_payment}
                    userlang={this.state.userlang}
                    get_cbs_language_cookie={this.get_cbs_language_cookie}
                  />
                  <Products
                    init_products={this.init_products}
                    products={this.state.products}
                    init_products_details_temp={this.init_products_details_temp}
                    products_detail_temp={this.state.temp_products_detail}
                    init_products_details={this.init_products_details}
                    products_detail={this.state.products_detail}
                    init_product_meta={this.init_product_meta}
                    set_child_products={this.set_child_products}
                    set_child_products_detail={this.set_child_products_detail}
                    children_products_detail={
                      this.state.children_products_detail
                    }
                    set_product_options={this.set_product_options}
                    set_product_sku={this.set_product_sku}
                    set_product_availability={this.set_product_availability}
                    set_product_price={this.set_product_price}
                    default_products={this.state.default_products}
                    parent_products_meta_data={
                      this.state.parent_products_meta_data
                    }
                  />
                </div>
                {/* <!--End of Left Column -->*/}
                {/*<!-- Right Coliumn --> */}
                <Ordersummary
                  basket={this.state.basket}
                  basket_lines={this.state.basket_lines}
                  order_total_incl_tax={this.state.order_total_incl_tax}
                  order_total_tax={this.state.order_total_tax}
                  step={this.state.step}
                  add_promo_code={this.add_promo_code}
                  promo_code_error={promo_code_error}
                  userlang={this.state.userlang}
                />
                {/* <!-- End of Right Coliumn --> */}
              </div>
            </div>
            {/* <!-- end of check page --></div> */}
          </React.Fragment>
        );
    }
  }
}

export default Checkout;
